const COLUMNS_CONFIG = [
  {
    name: 'name',
    header: {
      label: ctx => ctx.t('supervision.card.site')
    },
    value: site => site.name,
    sortBy: 'name',
    sortable: true
  },
  {
    name: 'connected_stations',
    header: {
      label: ctx => ctx.t('supervision.card.count_ap')
    },
    value: site => `${site.reachable_equipments}/${site.total_equipments}`,
    sortBy: 'connected_stations',
    sortable: true
  }
]

export default COLUMNS_CONFIG
